import { __awaiter } from "tslib";
import { PublicClientApplication } from '@azure/msal-browser';
export default class SSOService {
    static getInstance() {
        if (!this.instance) {
            this.instance = new SSOService();
        }
        return this.instance;
    }
    static getMSALInstance() {
        if (!this.msal) {
            this.msal = new PublicClientApplication({
                auth: {
                    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
                    authority: process.env.VUE_APP_MSAL_AUTHORITY,
                    postLogoutRedirectUri: process.env
                        .VUE_APP_MSAL_LOGOUT_REDIRECT
                },
                cache: {
                    cacheLocation: process.env.VUE_APP_MSAL_CACHE_LOCATION
                }
            });
        }
        return this.msal;
    }
    getActiveUser(msal) {
        return msal.getAllAccounts()[0];
    }
    getSilentRequest(account) {
        return {
            scopes: [process.env.VUE_APP_MSAL_SCOPE],
            account: account,
            forceRefresh: false
        };
    }
    getPopupRequest() {
        return {
            scopes: [process.env.VUE_APP_MSAL_SCOPE]
        };
    }
    getAccessToken(msal, account) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenResponse = null;
            try {
                const silentRequest = this.getSilentRequest(account);
                tokenResponse = yield msal.acquireTokenSilent(silentRequest);
                return tokenResponse.accessToken;
            }
            catch (e) {
                const request = this.getPopupRequest();
                tokenResponse = yield msal.acquireTokenPopup(request);
                return tokenResponse.accessToken;
            }
        });
    }
    getAccessTokenSilent(msal, account) {
        const silentRequest = this.getSilentRequest(account);
        return msal.acquireTokenSilent(silentRequest);
    }
    getAccessTokenPopup(msal) {
        return __awaiter(this, void 0, void 0, function* () {
            let tokenResponse = null;
            const request = this.getPopupRequest();
            tokenResponse = yield msal.acquireTokenPopup(request);
            return tokenResponse.accessToken;
        });
    }
}
